module.exports = __webpack_public_path__ + "img/4.fc11f32d.png";